webpackJsonp([22],{

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: false,
      show: true,
      bottomNav: '',
      sheet: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      to = to.fullPath;
      this.show = true;
      if (['/dashboard', '/equipments'].includes(to)) {
        this.bottomNav = to.slice(1);
      } else if (to === '/deviceDetail') {
        this.bottomNav = 'equipments';
      } else if (['/historics', '/settings'].includes(to)) {
        this.bottomNav = 'mas';
      } else if (['/', '/deviceCreation', '/signup', '/signup2', '/signin', '/newOrganization'].includes(to)) {
        this.show = false;
      }
    }
  },
  created: function created() {
    var currentPath = this.$route.path;
    if (['/dashboard', '/equipments'].includes(currentPath)) {
      this.bottomNav = currentPath.slice(1);
    } else if (['/historics', '/settings'].includes(currentPath)) {
      this.bottomNav = 'mas';
    } else if (['/', '/deviceCreation', '/signup', '/signup2', '/signin', '/newOrganization'].includes(currentPath)) {
      this.show = false;
    }
  },

  methods: {
    commignsoon: function commignsoon() {
      this.dialog = true;
    },
    replace: function replace(path) {
      if (path !== '/settings') {
        this.$router.replace(path);
      }
    },
    selectedSettings: function selectedSettings() {
      this.$router.replace('/userInfo');
      this.sheet = false;
    },
    trackMas: function trackMas() {
      mixpanel.track('Click Mas');
      gtag('event', 'click_mas', { event_category: 'click', event_label: 'Click Mas' });
    },
    onLogout: function onLogout() {
      mixpanel.track('Sign out');
      gtag('event', 'sign_out', { event_category: 'click', event_label: 'Sign out' });
      localStorage.setItem('auth_token', '');
      this.$store.dispatch('logout');
      this.$router.push('/');
      this.sheet = false;
    }
  }
});

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(782),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 782:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('coming-soon-modal', {
    attrs: {
      "dialog": _vm.dialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-bottom-nav', {
    staticClass: "bottomNavbar",
    attrs: {
      "active": _vm.bottomNav,
      "value": true
    },
    on: {
      "update:active": function($event) {
        _vm.bottomNav = $event
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "value": "dashboard"
    },
    on: {
      "click": function($event) {
        return _vm.replace('/dashboard')
      }
    }
  }, [_c('span', [_vm._v("Inicio")]), _vm._v(" "), _c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "value": "equipments"
    },
    on: {
      "click": function($event) {
        return _vm.replace('/equipments')
      }
    }
  }, [_c('span', [_vm._v("Equipos")]), _vm._v(" "), _c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "value": "mas"
    },
    on: {
      "click": function($event) {
        return _vm.trackMas()
      }
    },
    slot: "activator"
  }, [_c('span', [_vm._v("Mas")]), _vm._v(" "), _c('v-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.selectedSettings()
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Ajustes")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.commignsoon('/historics')
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    }
  }, [_c('v-icon', [_vm._v("history")])], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Históricos")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    }
  }, [_c('v-icon', [_vm._v("exit_to_app")])], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Cerrar sesión")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.6704e91294f2f250a1e2.js